import { render, staticRenderFns } from "./clRealSendReceive.vue?vue&type=template&id=332652dc&scoped=true&"
import script from "./clRealSendReceive.vue?vue&type=script&lang=js&"
export * from "./clRealSendReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332652dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('332652dc')) {
      api.createRecord('332652dc', component.options)
    } else {
      api.reload('332652dc', component.options)
    }
    module.hot.accept("./clRealSendReceive.vue?vue&type=template&id=332652dc&scoped=true&", function () {
      api.rerender('332652dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/clRealSendReceive.vue"
export default component.exports